import { t } from 'i18next';
import { RedirectPage } from '../../../components/redirect-page';
import { withPageProviders } from '../../../context/page-context';

export const PriceListsRedirectPage = withPageProviders(PriceListsRedirectContent);

function PriceListsRedirectContent() {
  return (
    <RedirectPage
      path="/pricing/lists"
      title={t('price_lists.redirect.title')}
      subtitle={t('price_lists.redirect.description')}
      action={t('price_lists.redirect.action')}
      imageType="priceList"
    />
  );
}
